import React from 'react';
import SalesDetailPage from './SalesDetailPage';
import { SORT_TYPES } from '../constants/sortTypes';
import {
  buildMemberFilterGroups,
  buildMemberApiFilters,
  memberColumns,
  memberReportBaseConfig,
  renderMemberCell,
} from '../constants/membershipReportShared';
import { currencyFormatter } from '../utils/reportingUtils';

const METRICS = [
  { key: 'events', label: 'Events', format: (v) => (v || 0).toLocaleString() },
  { key: 'tickets', label: 'Tickets', format: (v) => (v || 0).toLocaleString() },
  { key: 'add_ons', label: 'Add-ons', format: (v) => (v || 0).toLocaleString() },
  { key: 'donations', label: 'Donations', format: (v) => currencyFormatter.format(v || 0) },
];

const ENGAGEMENT_COLUMNS = memberColumns([
  { id: 'months_compared', label: 'Months Compared', defaultVisible: false, sortable: false },
  ...METRICS.flatMap(({ key, label }) => [
    { id: `${key}_before`, label: `${label} Before`, defaultVisible: true, sortable: false },
    { id: `${key}_after`, label: `${label} After`, defaultVisible: true, sortable: false },
  ]),
], { hidden: ['email', 'amount', 'interval'] });

const METRIC_FORMATS = Object.fromEntries(METRICS.flatMap(({ key, format }) => [
  [`${key}_before`, format],
  [`${key}_after`, format],
]));

const renderBaseCell = renderMemberCell([]);

const ENGAGEMENT_CONFIG = {
  ...memberReportBaseConfig({
    slug: 'engagement',
    title: 'Member Engagement',
    sidebarKey: 'memberships_engagement',
    localStorageName: 'reportingMembershipsEngagementColumns',
  }),
  pageSubtitle: 'Events attended, tickets, add-ons, and donations for each member in the same length of time before and after they joined (up to 12 months each way). Members who joined in the last 30 days are left out.',
  comparisonLabel: 'vs before joining',
  columns: ENGAGEMENT_COLUMNS.columns,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns: ENGAGEMENT_COLUMNS.getDefaultVisibleColumns,
  getDefaultHiddenColumns: ENGAGEMENT_COLUMNS.getDefaultHiddenColumns,
  defaultSortRules: [{ field: 'member_since', direction: 'desc' }],
  emptyMessage: 'No members have been members for at least 30 days.',

  buildFilterGroups: (venueOwnerships) => buildMemberFilterGroups({
    venueOwnerships, statuses: ['active', 'trialing', 'past_due', 'canceled', 'unpaid'],
  }),
  buildDetailApiFilters: buildMemberApiFilters(null),

  buildKpiCards: (current) => METRICS.map(({ key, label, format }) => ({
    label: `Avg ${label} per Member`,
    value: `${format(current[`${key}_before`])} → ${format(current[`${key}_after`])}`,
    current: current[`${key}_after`] || 0,
    prior: current[`${key}_before`] || 0,
  })),

  renderCellValue: (col, row, formatters) => (
    METRIC_FORMATS[col.id] ? METRIC_FORMATS[col.id](row[col.id]) : renderBaseCell(col, row, formatters)
  ),
};

function ReportingMembershipsEngagementPage(props) {
  return <SalesDetailPage {...props} config={ENGAGEMENT_CONFIG} />;
}

export default ReportingMembershipsEngagementPage;
